import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo, useCallback, useState } from 'react';
import { perm_details, unparse_weekschedule } from 'shared/device.acl/utils';
import { UniversalDialog } from 'console/dialogs/universal';
import { MessageBox } from 'shared/components/dialogs/message-box';
import { CustomRadioButton } from 'shared/components/fields';
import { Box, Button, IconButton, RadioGroup, Typography } from '@mui/material';
import * as moment from 'moment';
import { DevicePermission } from 'console/device/device_ts';
import { any2unix } from 'webui/utils/unixtime';
import { ControlWithoutValidation } from 'shared/components/fields/control/without-validation';
import { TextInputWrapper } from 'shared/components/fields/text';
import { ACLGroupId } from 'shared/device.acl/model/type';
import { ACLItemContent, getAclFormItem, } from 'shared/device.acl/ui/content';
import { useBox } from 'shared/hooks/utils';
import { useHelpPopup } from 'shared/hooks/ui';
import { HelpOutline } from '@mui/icons-material';
window.moment = moment;
function ACLFormDialogImpl(props) {
    const { acl, can_edit_settings, onRequestClose, onSave, open, owner_username, check_username, show_gps, } = props;
    const [activeControl, setActiveControl] = useState(acl != null && acl.group_id == ACLGroupId.support ? 'support' : 'username');
    const [username, setUsername] = useState(acl?.username ?? '');
    const boxedUsername = useBox(username);
    const [acl_item_form, setAclItemForm] = useState(getAclFormItem(acl));
    const boxedAclItem = useBox(acl_item_form);
    const [error, setError] = useState(null);
    const aclFromState = useCallback(() => ({
        username: boxedUsername.current,
        perms: boxedAclItem.current.perms,
        until: boxedAclItem.current.until != null
            ? boxedAclItem.current.until
            : undefined,
        not_before: boxedAclItem.current.not_before != null
            ? boxedAclItem.current.not_before
            : undefined,
        weekschedule: boxedAclItem.current.week_schedule.length > 0
            ? unparse_weekschedule(boxedAclItem.current.week_schedule)
            : undefined,
    }), []);
    const _onSave = useCallback(async () => {
        if (activeControl == 'support') {
            if (!boxedAclItem.current.perms.includes(DevicePermission.ext_configure)) {
                return setError('Технической поддержке необходимы полномочия на расширенную настройку');
            }
            onSave({
                ...aclFromState(),
                group_id: ACLGroupId.support,
                username: undefined,
            });
            return;
        }
        if (boxedUsername.current.trim().length === 0) {
            return setError('Введите имя пользователя');
        }
        if (boxedUsername.current.trim().toLowerCase() ===
            owner_username?.trim().toLowerCase()) {
            return setError('Вы уже являетесь владельцем устройства');
        }
        if (boxedAclItem.current.perms.length === 0) {
            return setError('Не выбраны полномочия');
        }
        try {
            const { exists } = await check_username(boxedUsername.current.trim());
            if (!exists) {
                return setError('Пользователь с таким логином не найден');
            }
            onSave(aclFromState());
        }
        catch (e) {
            console.error(e);
            return setError('Ошибка связи с сервером');
        }
    }, [activeControl, owner_username, check_username, onSave]);
    const closeErrorDialog = useCallback(() => setError(null), []);
    const onChooseSupport = useCallback(() => {
        setAclItemForm((item) => ({
            ...item,
            until: any2unix(new Date(Date.now() + 24 * 60 * 60e3)),
            perms: [...perm_details.keys()],
        }));
    }, []);
    const onSetActiveControl = useCallback((_, value) => {
        if (value == 'support') {
            onChooseSupport();
        }
        else {
            setAclItemForm((item) => ({
                ...item,
                until: null,
                perms: [],
            }));
        }
        setActiveControl(value);
    }, []);
    const [HelpPopup, openTooltip] = useHelpPopup();
    return (_jsxs(_Fragment, { children: [_jsx(UniversalDialog, { open: open, onClose: onRequestClose, title: "\u0421\u043E\u0432\u043C\u0435\u0441\u0442\u043D\u044B\u0439 \u0434\u043E\u0441\u0442\u0443\u043F", footer: _jsxs(_Fragment, { children: [_jsx(Box, { mr: 2, children: _jsx(Button, { onClick: onRequestClose, children: "\u043E\u0442\u043C\u0435\u043D\u0430" }) }), _jsx(Button, { onClick: _onSave, disabled: error != null, color: "primary", children: "\u041E\u041A" })] }), maxWidth: "sm", children: _jsx(ACLItemContent, { value: acl_item_form, onChange: setAclItemForm, readonly: can_edit_settings, show_gps: show_gps, validation_result: null, validation_warnings_result: null, children: _jsxs(RadioGroup, { defaultValue: "username", value: activeControl, onChange: onSetActiveControl, children: [_jsx(CustomRadioButton, { value: "username", children: _jsx(ControlWithoutValidation, { label: "\u041B\u043E\u0433\u0438\u043D \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F", field: TextInputWrapper, value: username, onChange: setUsername }) }), _jsxs(CustomRadioButton, { value: "support", children: ["\u0422\u0435\u0445.\u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0430", _jsx(IconButton, { size: "small", edge: "end", onClick: openTooltip, children: _jsx(HelpOutline, { fontSize: "small", color: "inherit" }) })] })] }) }) }), _jsx(MessageBox, { open: open && error != null, onClose: closeErrorDialog, title: "\u041D\u0435\u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u044B\u0435 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B", isError: true, children: _jsx(Typography, { children: error }) }), _jsx(HelpPopup, { children: _jsx(Typography, { variant: "subtitle1", children: "\u0427\u0435\u0440\u0435\u0437 \u0442\u0430\u043A\u0443\u044E \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0443 \u0432\u044B\u0434\u0430\u0451\u0442\u0441\u044F \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043B\u044F \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u0438\u0441\u0442\u043E\u0432 \u0442\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u043E\u0439 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438, \u0435\u0441\u043B\u0438 \u0432\u043A\u043B\u044E\u0447\u0451\u043D \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440 \u00AB\u0420\u0430\u0437\u0440\u0435\u0448\u0438\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430\u043C \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u0438\u0441\u0442\u0430\u043C \u0442\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u043E\u0439 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438\u00BB \u0432 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430\u0445 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0430" }) })] }));
}
export const ACLFormDialog = memo(ACLFormDialogImpl);
